<template>
  <div>
    <v-card outlined>
      <v-card-text>
        <v-row justify="space-between">
          <v-col md="2">
            <v-text-field
              v-model="filter.search"
              placeholder="Поиск по имени"
              dense
            />
          </v-col>
          <v-col md="3">
            <Select
                label="Присутствие:"
                v-model="filter.is_inside"
                :items="is_inside"
                item-text="name"
                item-value="id"
                class="fs-admin-complex-autocomplete"
                @change="getDataFromFirstPage"
                blank
                dense
                flat
            />
          </v-col>
          <v-col v-if="statistics" md="5">
            <v-row>
              <v-col md="6">
                <ul>
                  <li>Учеников в школе: {{ statistics.pupils.in_unit }}</li>
                  <li>Выдано карт ученикам: {{ statistics.pupils.all_cards }}</li>
                  <li>Учеников с картой: {{ statistics.pupils.with_card }}</li>
                  <li>Всего учеников: {{ statistics.pupils.all }}</li>
                </ul>
              </v-col>
              <v-col md="6">
                <ul>
                  <li>Всего в школе: {{ statistics.users.in_unit }}</li>
                  <li>Всего выдано карт: {{ statistics.users.all_cards }}</li>
                  <li>Всего с картой: {{ statistics.users.with_card }}</li>
                  <li>Всего пользователей: {{ statistics.users.all }}</li>
                </ul>
              </v-col>
            </v-row>
          </v-col>
          <v-col md="2">
            <Select
              label="Класс"
              v-model="filter.school_class"
              :items="classes"
              item-text="name"
              item-value="id"
              class="fs-admin-complex-autocomplete"
              @change="getDataFromFirstPage"
              blank
              dense
              flat
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <Table
              :headers="headers"
              :items="students"
              :items-per-page="studentsPerPage"
              :server-items-length="totalStudents"
              :page="page"
              :loading="loading"
              disable-sort
              @update:request="updateRequest"
              class="elevation-1"
            >
              <template v-slot:item.is_person_inside="{ item }">
                <v-icon v-if="item.is_person_inside">check</v-icon>
                <v-icon v-else>cancel</v-icon>
              </template>
              <template v-slot:item.cards="{ item }">
                <span v-for="(card, index) in item.cards" :key="card.number">
                  {{ card.number }}{{ item.cards.length - 1 > index ? ', ' : ''}}
                </span>
              </template>
              <template v-slot:item.parents="{ item }">
                <span v-for="(parent, index) in item.parents" :key="parent.parent_id">
                  {{ parent.full_name }}{{ item.parents.length - 1 > index ? ', ' : ''}}
                </span>
              </template>
              <template v-slot:item.agreement="{ item }">
                <span v-for="parent in item.parents" :key="parent.parent_id">
                  {{ parent.is_oferta_accepted ? parent.full_name : '' }}
                </span>
              </template>
              <template v-slot:item.edit="{ item }">
                <v-btn icon x-small @click="openInfoModal(item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
            </Table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <Modal
      v-if="selectedStudent"
      title="Информация об ученике"
      :dialog.sync="modals.infoDialog"
      @update:dialog="selectedStudent = null"
      contentClass="esh-theme adminModal"
    >
      <template #body>
        <v-card
          outlined
          class="infoBody"
        >
          <div>
            <h4>
              Л/C №{{selectedStudent.id}}
            </h4>
            <v-row>
              <v-col md="3">
                <v-avatar
                  color="teal"
                  size="60"
                  tile
                >
                </v-avatar>
              </v-col>
              <v-col md="9">
                <p>{{selectedStudent.full_name}}</p>
                <p>Класс: {{selectedStudent.school_class}}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6">
                <h3>Карты</h3>
                <div class="my-3" v-for="card in selectedStudent.cards" :key="card.id">
                  <CardInfoView
                    :card="card"
                    @card:edit="openCardModal(card)"
                  />
                </div>
                <v-alert
                  v-if="!selectedStudent.cards.length"
                  outlined
                  type="warning"
                  dense
                  class="mt-3"
                >
                  Студенту не выдана ката
                </v-alert>
                <v-btn
                  v-if="studentCanAddNewCard"
                  @click="modals.cardNewDialog = true"
                >
                  Выдача новой карты
                </v-btn>
              </v-col>
              <v-col md="6">
                <h3>Тарифы</h3>
                <v-select
                  label="Выберите родителя"
                  v-model="selectedStudent.selectedParentId"
                  :items="selectedStudent.parents"
                  dense
                  flat
                  item-text="full_name"
                  item-value="parent_id"
                  class="fs-admin-complex-autocomplete mt-6"
                />
                <div
                  v-if="selectedStudent.selectedParentId"
                  class="mt-3"
                >
                  <h4>{{ selectedParent.full_name }}</h4>
                  <p>
                    <v-checkbox
                      v-model="selectedParent.is_oferta_accepted"
                      label="Оферта принята"
                      @mouseup="modals.confirmDialog = true"
                    />
                  </p>
                  <p>Номер телефона: {{ selectedParent.phone || 'Не задан' }}</p>
                  <p>Email: {{ selectedParent.email || 'Не задан' }}</p>
                  <StudentPayerView
                    v-if="selectedPayer"
                    :payer="selectedPayer"
                    :parent="selectedParent"
                    :student="selectedStudent"
                    @update:payer="loadPayer(selectedStudent.id, selectedStudent.selectedParentId)"
                  />
                </div>
                <div v-else>
                  <v-alert outlined type="warning" dense class="mt-3">Выберите родителя для просмотра тарифов</v-alert>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </template>
    </Modal>
    <EditCardModal
      :card="selectedCard"
      :showCardModal.sync="modals.cardEditDialog"
      @onSaveEditedCard="onSaveEditedCard"
      :editCard="EDIT_CARD"
      :blockCard="BLOCK_CARD"
      :unlockCard="UNLOCK_CARD"
    />
    <NewCardModal
      :showCardModal.sync="modals.cardNewDialog"
      :user="selectedStudent"
      @card:save="createCard($event)"
    />
    <ConfirmModal
      v-if="selectedParent"
      title="Внимание"
      :dialog.sync="modals.confirmDialog"
      :confirmBtnText="selectedParent.is_oferta_accepted ? 'Принять' : 'Отклонить'"
      contentClass="esh-theme adminModal"
      @confirm="updateOfferta(selectedStudent.id, selectedParent.parent_id, selectedParent.is_oferta_accepted)"
      @reject="selectedParent.is_oferta_accepted = !selectedParent.is_oferta_accepted"
    >
      <template #body>
        <v-col v-if="selectedParent.is_oferta_accepted">
          Вы точно хотите принять оферту вместо родителя?
        </v-col>
        <v-col v-else>
          Вы точно хотите отклонить оферту для родителя?
        </v-col>
      </template>
    </ConfirmModal>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { BASE } from '@/config'
import { Modal, ConfirmModal, Table, Select } from '@/components/common'
import EditCardModal from '@/components/cards/EditCardModal'
import NewCardModal from '@/components/cards/NewCardModal'
import CardInfoView from '@/components/cards/CardInfoView'
import StudentPayerView from '@/views/admin/users/StudentPayerView'
import {
  GET_ADMIN_STUDENTS,
  GET_ADMIN_CLASSES,
  GET_ADMIN_STATISTICS,
  GET_ADMIN_PAYER,
  ADMIN_UPDATE_STUDENT_PARENT,
  CREATE_CARD,
  EDIT_CARD,
  BLOCK_CARD,
  UNLOCK_CARD
} from '@/requests/admin'

export default {
  name: 'Students',
  components: {
    Modal,
    ConfirmModal,
    Table,
    Select,
    StudentPayerView,
    CardInfoView,
    EditCardModal,
    NewCardModal
  },
  data: () => ({
    EDIT_CARD,
    BLOCK_CARD,
    UNLOCK_CARD,
    selectedStudent: null,
    selectedPayer: null,
    selectedCard: {},
    headers: [
      { text: 'Присутстствие', value: 'is_person_inside' },
      { text: 'ID', value: 'id' },
      { text: 'ФИО', value: 'full_name' },
      { text: 'Класс', value: 'school_class' },
      { text: 'Карты', value: 'cards' },
      { text: 'Родители', value: 'parents' },
      { text: 'Приняли оферту', value: 'agreement' },
      { text: 'Редактирование', value: 'edit' },
    ],
    classes: [],
    students: [],
    page: 1,
    studentsPerPage: BASE.LIMIT,
    totalStudents: 0,
    loading: false,
    modals: {
      infoDialog: false,
      tariffDialog: false,
      cardEditDialog: false,
      cardNewDialog: false,
      confirmDialog: false
    },
    statistics: null,
    filter: {
      search: '',
      school_class: null,
      is_inside: null
    },
    is_inside: [
      { id: null, name: '-' },
      { id: true, name: 'В школе' },
      { id: false, name: 'Не в школе' }
    ]
  }),
  created() {
    this.getData()
    this.loadClasses()
    this.loadStatistics()
  },
  watch: {
    'selectedStudent.selectedParentId': function (parentId) {
      if (typeof parentId !== 'undefined') {
        this.loadPayer(this.selectedStudent.id, parentId)
      }
    },
    'modals.infoDialog': function (state) {
      if (!state) {
        this.selectedStudent = null
        this.selectedPayer = null
      }
    },
    'filter.search': function(state, prevState) {
      if (state.length > prevState.length && state.length >= BASE.SEARCH_MIN_LETTERS) {
        this.searchStudents()
      } else if (state.length < prevState.length && prevState.length >= BASE.SEARCH_MIN_LETTERS) {
        this.searchStudents()
      }
    }
  },
  computed: {
    selectedParent() {
      if (this.selectedStudent && this.selectedStudent.selectedParentId) {
        return this.selectedStudent.parents.find(p => p.parent_id === this.selectedStudent.selectedParentId)
      }
      return null
    },
    studentCanAddNewCard() {
      if (this.selectedStudent) {
        if (!this.selectedStudent.cards.length) return true
        const activeCard = this.selectedStudent.cards.find(c => !c.is_expired && !c.is_blocked)
        return !activeCard
      }
      return false
    }
  },
  methods: {
    openInfoModal(item) {
      this.selectedStudent = item
      this.modals.infoDialog = true
    },
    openCardModal(card) {
      this.selectedCard = card
      this.modals.cardEditDialog = true
    },
    onSaveEditedCard(card) {
      Object.keys(this.selectedCard).forEach(key => this.selectedCard[key] = card[key])
      this.selectedCard = {}
    },
    searchStudents: debounce(function() {
      this.getDataFromFirstPage()
    }, 300),
    getDataFromFirstPage() {
      this.page = 1
      this.getData()
    },
    updateRequest({ page, itemsPerPage, offset }) {
      this.studentsPerPage = itemsPerPage
      this.page = page
      this.getData({ offset: offset })
    },
    async getData(params = {}) {
      try {
        this.loading = true
        let { data: { results, count } } = await GET_ADMIN_STUDENTS({
          limit: this.studentsPerPage,
          full_name: this.filter.search.length >= BASE.SEARCH_MIN_LETTERS ? this.filter.search : '',
          school_class: this.filter.school_class,
          is_inside: this.filter.is_inside,
          ...params
        })

        this.students = results
        this.totalStudents = count
      } catch (error) {
        console.log(error)
        this.$notify({
          type: 'error',
          text: 'Не удалось получить данные по ученикам школы'
        })
      } finally {
        this.loading = false
      }
    },
    async loadClasses() {
      try {
        let response = await GET_ADMIN_CLASSES()
        this.classes = response.data.results
      } catch {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить информацию о классах'
        })
      }
    },
    async loadStatistics() {
      try {
        let { data } = await GET_ADMIN_STATISTICS()
        this.statistics = data
      } catch {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить статистику по школе'
        })
      }
    },
    async loadPayer(childId, parentId) {
      try {
        let { data } = await GET_ADMIN_PAYER(parentId, childId)
        this.selectedPayer = data
      } catch(error) {
        console.log(error)
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить информацию о тарифах пользователя'
        })
      }
    },
    async updateOfferta(childId, parentId, state) {
      try {
        await ADMIN_UPDATE_STUDENT_PARENT(parentId, childId, {
          is_oferta_accepted: state
        })
        this.$notify({
          type: 'success',
          text: `Оферта для родителя ${state ? 'принята' : 'отклонена'}`
        })
      } catch(error) {
        console.log(error)
        this.$notify({
          type: 'error',
          text: 'Не удалось обновить данные по оферте'
        })
      }
    },
    async createCard(card) {
      try {
        const { data } = await CREATE_CARD(card)
        this.selectedStudent.cards.unshift(data)
        this.$notify({
          type: 'success',
          text: `Карта №${card.number} успешно создана!`
        })
      } catch(error) {
        console.log(error)
        this.$notify({
          type: 'error',
          text: 'Не удалось создать новую карту'
        })
      }
    }
  }
}
</script>
